<script>
    import { sgettext } from '../../../i18n.js';

    export let rows = [];
    export let isVerticalLayout = false;
</script>

{#if isVerticalLayout}
<div class="table-container-vertical">
    <table class='sw table mb-0 border table-hover'>
        {#if rows.length != 0}
            <thead class='thead-light'>
                <tr>
                    <th colspan='2'>{sgettext('$$ENERGY_MECHANISM$$')}</th>
                    <th>{sgettext('$$RISK_CONTROL$$')}</th>
                </tr>
            </thead>
        {/if}
        <tbody>
            {#each rows as row, i}
                <tr class:border-red="{row.invalid_hazard_control}">
                    <td class="{row.invalid_hazard_control ? 'padding-35' : 'padding-0'}">
                        {#if row.invalid_hazard_control}
                            <i class='fa fa-exclamation-circle text-danger'></i>
                        {/if}
                    </td>

                    <td class='field'>
                        <div class="field-container" title="{row.mechanism.name}">
                            <div class="wrapper-vertical">
                                <img
                                    src="{row.mechanism.energy_type.icon.url}"
                                    alt="{row.mechanism.energy_type.name}"
                                />
                                <div class="text">{row.mechanism.energy_type.name}</div>
                                <div class="subtext">{row.mechanism.name}</div>
                            </div>
                        </div>
                    </td>
                    <td class='field'>
                        <div class="field-container" title="{row.global_hazard.name}: {row.global_hazard.description}">
                            <div class="wrapper">
                                <img
                                    src="{row.global_hazard.icon.url}"
                                    alt="{row.global_hazard.name}"
                                />
                                <div class="label-container">
                                    <div class="text">{row.global_hazard.name}</div>
                                    <div class="subtext">{row.global_hazard.description}</div>
                                </div>
                            </div>
                        </div>
                        <div class="field-container" title="{row.global_control.name}: {row.global_control.description}">
                            <div class="wrapper">
                                <img
                                    src="{row.global_control.icon.url}"
                                    alt="{row.global_control.name}"
                                />
                                <div class="label-container">
                                    <div class="text">{row.global_control.name}</div>
                                    <div class="subtext">{row.global_control.description}</div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            {:else}
                <tr>
                    <td>{sgettext('$$NONE$$')}</td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>

{:else}
<div class="table-container">
    <table class='sw table mb-0 border table-hover'>
        {#if rows.length != 0}
            <thead class='thead-light'>
                <tr>
                    <th colspan='2'>{sgettext('$$ENERGY_MECHANISM$$')}</th>
                    <th>{sgettext('$$RISK$$')}</th>
                    <th>{sgettext('$$CONTROL$$')}</th>
                </tr>
            </thead>
        {/if}
        <tbody>
            {#each rows as row, i}
                <tr class:border-red="{row.invalid_hazard_control}">
                    <td class="{row.invalid_hazard_control ? 'padding-35' : 'padding-0'}">
                        <!-- There are actually a few reasons now why the hazard+control could be invalid so having
                        a single blanket message is not all that helpful or even accurate. -->
                        <!--{#if row.invalid_hazard_control}-->
<!--                            <i class='fa fa-exclamation-circle text-danger' title={sgettext('$$NOT_VALID_RISK_CONTROL_COMBINATION$$')}></i>-->
<!--                        {/if}-->
                        {#if row.invalid_hazard_control}
                            <i class='fa fa-exclamation-circle text-danger'></i>
                        {/if}

                    </td>

                    <td class='field'>
                        <div class="field-container" title="{row.mechanism.name}">
                            <div class="wrapper">
                                <img
                                    src="{row.mechanism.energy_type.icon.url}"
                                    alt="{row.mechanism.energy_type.name}"
                                />
                                <div class="label-container">
                                    <div class="text">{row.mechanism.energy_type.name}</div>
                                    <div class="subtext">{row.mechanism.name}</div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class='field'>
                        <div class="field-container" title="{row.global_hazard.name}: {row.global_hazard.description}">
                            <div class="wrapper">
                                <img
                                    src="{row.global_hazard.icon.url}"
                                    alt="{row.global_hazard.name}"
                                />
                                <div class="label-container">
                                    <div class="text">{row.global_hazard.name}</div>
                                    <div class="subtext">{row.global_hazard.description}</div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class='field'>
                        <div class="field-container" title="{row.global_control.name}: {row.global_control.description}">
                            <div class="wrapper">
                                <img
                                    src="{row.global_control.icon.url}"
                                    alt="{row.global_control.name}"
                                />
                                <div class="label-container">
                                    <div class="text">{row.global_control.name}</div>
                                    <div class="subtext">{row.global_control.description}</div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            {:else}
                <tr>
                    <td>{sgettext('$$NONE$$')}</td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>
{/if}

<style>
    th {
        width: 33%;
    }

    .table-container {
        margin-bottom: 15px;
    }

    .table-container-vertical {
        margin-bottom: 15px;
    }

    .field-container {
        box-sizing: border-box;
        height: 72px;
        position: relative;
        display: grid;
        align-items: center;
        padding: 0;
        margin: 0;
    }

    .wrapper {
        overflow: hidden;
        display: flex;
        flex-direction: row;
    }

    .wrapper-vertical {
        display: flex;
        flex-direction: column;
    }

    .table-container .wrapper img {
        flex: 0 0 50px;
        margin: auto 10px;
        width: 50px;
        height: 50px;
    }

    .table-container .label-container {
        flex: 1 1 200px;
        margin: auto 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .table-container .label-container .text {
        font-weight: bold;
        font-size: medium;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .table-container .label-container .subtext {
        font-weight: normal;
        font-size: small;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .table-container-vertical .wrapper-vertical img {
        flex: 0 0 50px;
        margin: 10px 0 5px 0;
        padding-bottom: 10px;
        width: 50px;
        height: 50px;
        overflow: hidden;
    }

    .table-container-vertical .wrapper-vertical .text {
        font-weight: bold;
        font-size: medium;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: normal;
    }

    .table-container-vertical .wrapper-vertical .subtext {
        font-weight: normal;
        font-size: small;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: normal;
    }

    .table-container-vertical .wrapper img {
        flex: 0 0 30px;
        margin: auto 5px;
        width: 30px;
        height: 30px;
        overflow: hidden;
    }

    .table-container-vertical .wrapper .text {
        font-weight: bold;
        font-size: medium;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .table-container-vertical .wrapper .subtext {
        font-weight: normal;
        font-size: small;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .border-red {
        border: #ff0000 solid 3px;
    }

    .padding-0 {
        padding: 0;
    }

    .padding-35 {
        padding: 35px 0 35px 5px;
    }
</style>
